var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.tiles},[(_vm.symbols.length > 0)?_c('div',{class:_vm.symbols}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }